// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"0":"623a9b11f180aae3","723":"e26d4d17c244c97b"}[chunkId] + ".css";
};